import { createAction } from '@reduxjs/toolkit';
import { Asset, Tag } from '../../api';

export const tagsLoaded = createAction<{ tags: Tag[] }, 'al/tagBinder/tagsLoaded'>(
  'al/tagBinder/tagsLoaded',
);

export const setVisible = createAction<{ visible: boolean }, 'al/tagBinder/setVisible'>(
  'al/tagBinder/setVisible',
);

export const setInProgress = createAction<{ inProgress: boolean }, 'al/tagBinder/setInProgress'>(
  'al/tagBinder/setInProgress',
);

export const submitted = createAction<
  { tagIds: Tag['id'][]; assetIds?: Asset['id'][]; selectAll?: boolean },
  'al/tagBinder/submitted'
>('al/tagBinder/submitted');

export const completed = createAction<void, 'al/tagBinder/completed'>('al/tagBinder/completed');
